export default __webpack_public_path__ + "static/media/shoulderstand.784f28f4.jpg";